
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/sectionizer/panels/sectionizerPanel/sectionNamePanel.scss.css.virtualfile';
        module.exports = {"search-container":"_search-container_h4xj9_1","searchContainer":"_search-container_h4xj9_1"};